/**
 * Contact Form - Dynamic Functionality
 * Handles conditional fields, state/province dropdowns, and form validation
 */

(function() {
  'use strict';

  // US States
  const US_STATES = [
    { value: 'AL', label: 'Alabama' },
    { value: 'AK', label: 'Alaska' },
    { value: 'AZ', label: 'Arizona' },
    { value: 'AR', label: 'Arkansas' },
    { value: 'CA', label: 'California' },
    { value: 'CO', label: 'Colorado' },
    { value: 'CT', label: 'Connecticut' },
    { value: 'DE', label: 'Delaware' },
    { value: 'FL', label: 'Florida' },
    { value: 'GA', label: 'Georgia' },
    { value: 'HI', label: 'Hawaii' },
    { value: 'ID', label: 'Idaho' },
    { value: 'IL', label: 'Illinois' },
    { value: 'IN', label: 'Indiana' },
    { value: 'IA', label: 'Iowa' },
    { value: 'KS', label: 'Kansas' },
    { value: 'KY', label: 'Kentucky' },
    { value: 'LA', label: 'Louisiana' },
    { value: 'ME', label: 'Maine' },
    { value: 'MD', label: 'Maryland' },
    { value: 'MA', label: 'Massachusetts' },
    { value: 'MI', label: 'Michigan' },
    { value: 'MN', label: 'Minnesota' },
    { value: 'MS', label: 'Mississippi' },
    { value: 'MO', label: 'Missouri' },
    { value: 'MT', label: 'Montana' },
    { value: 'NE', label: 'Nebraska' },
    { value: 'NV', label: 'Nevada' },
    { value: 'NH', label: 'New Hampshire' },
    { value: 'NJ', label: 'New Jersey' },
    { value: 'NM', label: 'New Mexico' },
    { value: 'NY', label: 'New York' },
    { value: 'NC', label: 'North Carolina' },
    { value: 'ND', label: 'North Dakota' },
    { value: 'OH', label: 'Ohio' },
    { value: 'OK', label: 'Oklahoma' },
    { value: 'OR', label: 'Oregon' },
    { value: 'PA', label: 'Pennsylvania' },
    { value: 'RI', label: 'Rhode Island' },
    { value: 'SC', label: 'South Carolina' },
    { value: 'SD', label: 'South Dakota' },
    { value: 'TN', label: 'Tennessee' },
    { value: 'TX', label: 'Texas' },
    { value: 'UT', label: 'Utah' },
    { value: 'VT', label: 'Vermont' },
    { value: 'VA', label: 'Virginia' },
    { value: 'WA', label: 'Washington' },
    { value: 'WV', label: 'West Virginia' },
    { value: 'WI', label: 'Wisconsin' },
    { value: 'WY', label: 'Wyoming' }
  ];

  // Canadian Provinces
  const CA_PROVINCES = [
    { value: 'AB', label: 'Alberta' },
    { value: 'BC', label: 'British Columbia' },
    { value: 'MB', label: 'Manitoba' },
    { value: 'NB', label: 'New Brunswick' },
    { value: 'NL', label: 'Newfoundland and Labrador' },
    { value: 'NS', label: 'Nova Scotia' },
    { value: 'ON', label: 'Ontario' },
    { value: 'PE', label: 'Prince Edward Island' },
    { value: 'QC', label: 'Quebec' },
    { value: 'SK', label: 'Saskatchewan' },
    { value: 'NT', label: 'Northwest Territories' },
    { value: 'NU', label: 'Nunavut' },
    { value: 'YT', label: 'Yukon' }
  ];

  // Mexican States
  const MX_STATES = [
    { value: 'AGU', label: 'Aguascalientes' },
    { value: 'BCN', label: 'Baja California' },
    { value: 'BCS', label: 'Baja California Sur' },
    { value: 'CAM', label: 'Campeche' },
    { value: 'CHP', label: 'Chiapas' },
    { value: 'CHH', label: 'Chihuahua' },
    { value: 'COA', label: 'Coahuila' },
    { value: 'COL', label: 'Colima' },
    { value: 'DIF', label: 'Ciudad de México' },
    { value: 'DUR', label: 'Durango' },
    { value: 'GUA', label: 'Guanajuato' },
    { value: 'GRO', label: 'Guerrero' },
    { value: 'HID', label: 'Hidalgo' },
    { value: 'JAL', label: 'Jalisco' },
    { value: 'MEX', label: 'México' },
    { value: 'MIC', label: 'Michoacán' },
    { value: 'MOR', label: 'Morelos' },
    { value: 'NAY', label: 'Nayarit' },
    { value: 'NLE', label: 'Nuevo León' },
    { value: 'OAX', label: 'Oaxaca' },
    { value: 'PUE', label: 'Puebla' },
    { value: 'QUE', label: 'Querétaro' },
    { value: 'ROO', label: 'Quintana Roo' },
    { value: 'SLP', label: 'San Luis Potosí' },
    { value: 'SIN', label: 'Sinaloa' },
    { value: 'SON', label: 'Sonora' },
    { value: 'TAB', label: 'Tabasco' },
    { value: 'TAM', label: 'Tamaulipas' },
    { value: 'TLA', label: 'Tlaxcala' },
    { value: 'VER', label: 'Veracruz' },
    { value: 'YUC', label: 'Yucatán' },
    { value: 'ZAC', label: 'Zacatecas' }
  ];

  // Australian States and Territories
  const AU_STATES = [
    { value: 'ACT', label: 'Australian Capital Territory' },
    { value: 'NSW', label: 'New South Wales' },
    { value: 'NT', label: 'Northern Territory' },
    { value: 'QLD', label: 'Queensland' },
    { value: 'SA', label: 'South Australia' },
    { value: 'TAS', label: 'Tasmania' },
    { value: 'VIC', label: 'Victoria' },
    { value: 'WA', label: 'Western Australia' }
  ];

  // French Regions
  const FR_REGIONS = [
    { value: 'ARA', label: 'Auvergne-Rhône-Alpes' },
    { value: 'BFC', label: 'Bourgogne-Franche-Comté' },
    { value: 'BRE', label: 'Bretagne' },
    { value: 'CVL', label: 'Centre-Val de Loire' },
    { value: 'COR', label: 'Corse' },
    { value: 'GES', label: 'Grand Est' },
    { value: 'HDF', label: 'Hauts-de-France' },
    { value: 'IDF', label: 'Île-de-France' },
    { value: 'NOR', label: 'Normandie' },
    { value: 'NAQ', label: 'Nouvelle-Aquitaine' },
    { value: 'OCC', label: 'Occitanie' },
    { value: 'PDL', label: 'Pays de la Loire' },
    { value: 'PAC', label: 'Provence-Alpes-Côte d\'Azur' }
  ];

  // German States (Länder)
  const DE_STATES = [
    { value: 'BW', label: 'Baden-Württemberg' },
    { value: 'BY', label: 'Bavaria (Bayern)' },
    { value: 'BE', label: 'Berlin' },
    { value: 'BB', label: 'Brandenburg' },
    { value: 'HB', label: 'Bremen' },
    { value: 'HH', label: 'Hamburg' },
    { value: 'HE', label: 'Hesse (Hessen)' },
    { value: 'MV', label: 'Mecklenburg-Vorpommern' },
    { value: 'NI', label: 'Lower Saxony (Niedersachsen)' },
    { value: 'NW', label: 'North Rhine-Westphalia (Nordrhein-Westfalen)' },
    { value: 'RP', label: 'Rhineland-Palatinate (Rheinland-Pfalz)' },
    { value: 'SL', label: 'Saarland' },
    { value: 'SN', label: 'Saxony (Sachsen)' },
    { value: 'ST', label: 'Saxony-Anhalt (Sachsen-Anhalt)' },
    { value: 'SH', label: 'Schleswig-Holstein' },
    { value: 'TH', label: 'Thuringia (Thüringen)' }
  ];

  // UK Countries/Regions
  const GB_REGIONS = [
    { value: 'ENG', label: 'England' },
    { value: 'SCT', label: 'Scotland' },
    { value: 'WLS', label: 'Wales' },
    { value: 'NIR', label: 'Northern Ireland' }
  ];

  class ContactForm {
    constructor() {
      this.form = document.querySelector('.contact-form-wrapper form');
      if (!this.form) return;

      this.reasonSelect = document.querySelector('[data-contact-reason]');
      this.productInfoSection = document.querySelector('[data-product-info]');
      this.contactDetailsSection = document.querySelector('[data-contact-details]');
      this.contactCommentsSection = document.querySelector('[data-contact-comments]');
      this.contactActionsSection = document.querySelector('[data-contact-actions]');
      this.countrySelect = document.getElementById('contact-country');
      this.stateSelect = document.getElementById('contact-state');

      this.init();
    }

    init() {
      this.setupReasonToggle();
      this.setupCountryStateDropdowns();
      this.setupTooltips();
      this.setupFormValidation();
    }

    setupReasonToggle() {
      if (!this.reasonSelect || !this.productInfoSection) return;

      this.reasonSelect.addEventListener('change', (e) => {
        const productFields = this.productInfoSection.querySelectorAll('input');
        if( e.target.value != '') {
          this.contactDetailsSection.style.display = 'block';
          this.contactCommentsSection.style.display = 'block';
          this.contactActionsSection.style.display = 'block';
        } else {
          this.contactDetailsSection.style.display = 'none';
          this.contactCommentsSection.style.display = 'none';
          this.contactActionsSection.style.display = 'none';
        }

        if (e.target.value === 'product') {
          this.productInfoSection.style.display = 'block';
        } else {
          this.productInfoSection.style.display = 'none';
          productFields.forEach(field => field.value = '');
        }
      });
    }

    setupCountryStateDropdowns() {
      if (!this.countrySelect || !this.stateSelect) return;

      // Initialize with first country selection (if any is selected)
      const initialCountry = this.countrySelect.value;
      if (initialCountry && initialCountry !== '') {
        this.updateStateOptions(initialCountry);
      }

      // Listen for country changes
      this.countrySelect.addEventListener('change', (e) => {
        this.updateStateOptions(e.target.value);
      });
    }

    updateStateOptions(country) {
      let states = [];
      let label = 'Select State';

      // If no country selected, show placeholder
      if (!country || country === '') {
        this.stateSelect.innerHTML = `<option value="">Select State</option>`;
        this.stateSelect.setAttribute('disabled', '');
        return;
      }

      // Enable the state select
      this.stateSelect.removeAttribute('disabled');

      switch(country) {
        case 'US':
          states = US_STATES;
          label = 'Select State';
          break;
        case 'CA':
          states = CA_PROVINCES;
          label = 'Select Province';
          break;
        case 'MX':
          states = MX_STATES;
          label = 'Select State';
          break;
        case 'AU':
          states = AU_STATES;
          label = 'Select State/Territory';
          break;
        case 'FR':
          states = FR_REGIONS;
          label = 'Select Region';
          break;
        case 'DE':
          states = DE_STATES;
          label = 'Select State';
          break;
        case 'GB':
          states = GB_REGIONS;
          label = 'Select Country/Region';
          break;
        case 'Other':
          states = [];
          label = 'State/Region';
          break;
        default:
          states = [];
          label = 'Select State';
      }

      this.stateSelect.innerHTML = `<option value="">Select State</option>`;

      states.forEach(state => {
        const option = document.createElement('option');
        option.value = state.value;
        option.textContent = state.label;
        this.stateSelect.appendChild(option);
      });

      // For "Other" country, make state field optional
      if (country === 'Other') {
        this.stateSelect.removeAttribute('required');
      } else {
        this.stateSelect.setAttribute('required', '');
      }

      const stateLabel = document.querySelector('label[for="contact-state"]');
      if (stateLabel) {
        const requiredSpan = stateLabel.querySelector('.required');
        stateLabel.innerHTML = `${label} `;
        if (requiredSpan && country !== 'Other') {
          stateLabel.appendChild(requiredSpan.cloneNode(true));
        }
      }
    }

    setupTooltips() {
      const tooltips = document.querySelectorAll('.info-tooltip');
      
      tooltips.forEach(tooltip => {
        tooltip.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          const tooltipId = tooltip.getAttribute('data-tooltip-id');
          const tooltipBox = document.getElementById(tooltipId);
          
          if (tooltipBox) {
            // Cerrar todos los tooltips abiertos
            document.querySelectorAll('.tooltip-box').forEach(box => {
              if (box.id !== tooltipId) {
                box.style.display = 'none';
              }
            });
            
            // Toggle del tooltip actual
            if (tooltipBox.style.display === 'none' || !tooltipBox.style.display) {
              tooltipBox.style.display = 'block';
            } else {
              tooltipBox.style.display = 'none';
            }
          } else {
            // Fallback para tooltips antiguos con data-tooltip
            const message = tooltip.getAttribute('data-tooltip');
            if (message) {
              alert(message);
            }
          }
        });
      });
      
      // Cerrar tooltips al hacer clic fuera
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.info-tooltip') && !e.target.closest('.tooltip-box')) {
          document.querySelectorAll('.tooltip-box').forEach(box => {
            box.style.display = 'none';
          });
        }
      });
    }

    setupFormValidation() {
      this.form.addEventListener('submit', (e) => {
        const email = this.form.querySelector('#contact-email');
        
        if (email && !this.isValidEmail(email.value)) {
          e.preventDefault();
          alert('Please enter a valid email address');
          email.focus();
          return false;
        }

        return true;
      });
    }

    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new ContactForm());
  } else {
    new ContactForm();
  }
})();